"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.CartType=void 0;var e;(function(t){t.EmptyCart="EmptyCart",t.ProductList="ProductList",t.ProductNotAvailable="ProductNotAvailable"})(e||(exports.CartType=e={}));
//# sourceMappingURL=CartType.js.map
